<template>
  <div class="divider" :class="{ vertical }" :style="{ height }" />
</template>

<script setup lang="ts">
defineProps<{
  vertical?: boolean;
  height?: string;
}>();
</script>

<style scoped lang="scss">
.divider {
  width: 100%;
  height: 1.2px;

  background: url('@/assets/img/common/devider.svg') repeat-x center center / auto 100%;

  @include md-and-down {
    height: 1.5px;
  }

  &.vertical {
    width: 1px;
    height: 100%;

    background: url('@/assets/img/common/vertical-line.png') repeat-y center center / 100% auto;
  }
}
</style>
